import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../services/helpers.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

declare var google: any;

@Component({ standalone: false,
  selector: 'vfa-cp-disabled-address-input',
  templateUrl: './disabled-address-input.component.html',
  styleUrls: ['./disabled-address-input.component.scss'],
  providers: []
})
export class DisabledAddressInputComponent implements OnInit, OnChanges {
  @Input() label: string = "";
  @Input() value: string = "";
  @Input() isCountry: boolean = false;

  public labelTranslated: string = "";
  public valueTranslated: string = "";

  private REGISTRATION_COUNTRY_PREFIX: string = '';

  constructor(private helpersService: HelpersService, protected translate: TranslateService) {}

  ngOnInit() {
    this.REGISTRATION_COUNTRY_PREFIX = this.helpersService.config?.REGISTRATION_COUNTRY_PREFIX || 'registration-country-';
    this.populateDisabledInput();
  }

  ngOnChanges(change: any) {
    if(change.label) {
      this.label = change.label.currentValue;
    } else if(change.value) {
      this.value = change.value.currentValue;
    }
    this.populateDisabledInput();
  }

  populateDisabledInput() {
    if(this.label) {
      this.labelTranslated = this.label;
    } else {
      this.labelTranslated = "";
    }
    if(this.isCountry && this.value) {
      this.valueTranslated = this.REGISTRATION_COUNTRY_PREFIX + this.value;
    } else if(!this.isCountry && this.value) {
      this.valueTranslated = this.value;
    } else {
      this.valueTranslated = "";
    }
  }

}

